// extracted by mini-css-extract-plugin
export default {"icon":"styles_icon__xYlQg","discard":"styles_discard__wFsiX"};